import * as React from "react";
import {Page, Text, View, Document, StyleSheet} from '@react-pdf/renderer';
import {PDFViewer} from '@react-pdf/renderer';
import ApprovedLandUseReport from "./templates/approved_land_use";
import VillageStatusLandUseReport from "./templates/village_status_land_use";
import {ReportService} from "../../../service/v1/report";
import PopDetail from "../../popdetail";
import baseUrl from "../../../service/baseURL";


export default class ReportContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            current_report: "Loading ..."
        }
        this.getReport = this.getReport.bind(this)
    }

    componentDidMount() {
        console.log(this.props.report)

        let report_code = this.props.report.endpoint
        console.log('App : ' + report_code)
        this.getReport(report_code)
    }

    getReport(code) {
        ReportService.fetchReport(code).then(r => {
            try {
                console.log('YYYYYYYY')
                this.setState({
                    current_report: r.data,
                })
            } catch (e) {
                console.log(e)
            }
            console.log('RRRRRRR')
        })
    }

    render() {
        return (<div className={'row'}>
            <div className={'col col-sm-1'}/>
            <div className={'col col-sm-10'} style={{border: '1px solid #ccc', boxShadow: '0 0 40px #ccc'}}>
                <div style={{padding:'20px'}}>
                    <button className={'btn-list'} title={'Download PDF'} style={{float:'right'}}
                            onClick={() => ReportContainer.downloadReport(this.props.report.endpoint, 'pdf')}>
                        <span className={'fa-solid fa-file-pdf fa-xl'}/>
                    </button>

                    <button className={'btn-list'} title={'Download EXCEL'} style={{float:'right'}}
                            onClick={() => ReportContainer.downloadReport(this.props.report.endpoint, 'excel')}>
                        <span className={'fa-solid fa-file-excel fa-xl'}/>
                    </button>

                    <button className={'btn-list'} title={'Download GRAPH'} style={{float:'right'}}
                            onClick={() => ReportContainer.downloadReport(this.props.report.endpoint, 'graph')}>
                        <span className={'fa-solid fa-bar-chart fa-xl'}/>
                    </button>
                </div>

                <div style={{width: "100%", height: "90vh", overflow: "auto"}}>
                    {/* <PDFViewer style={{width: "100%", height: "1000px"}}>*/}
                    {/*{this.state.current_report}*/}
                    <div dangerouslySetInnerHTML={{__html: this.state.current_report}}/>
                    {/* </PDFViewer>*/}
                </div>
            </div>
        </div>)

    }

    static downloadReport(code, format) {
        ReportService.downloadReport(code,format).then(response => this.loadImage(response.data, code, format)
      );
    }

    static loadImage( data, code, format ) {

        let ext = format === 'excel' ? '.xlsx' : format === 'pdf' ? '.pdf' : '.png'
        let type = format === 'excel' ? '' : format === 'pdf' ? 'application/pdf' : 'image/png'
        // we can all pass them to the Blob constructor directly
        const new_blob = new Blob( [ data ], { type: 'application/'+type } );
        // with blob: URI, the browser will try to load 'data' as-is
        const url = URL.createObjectURL( new_blob );
        //window.open(url);
        let a = document.createElement('a');
        a.href = url;
        a.download = code + ext;
        a.click();

    }

}